<p>svg-factory rendered {{polygonCount}} graphics</p>
